import React, { useContext, useEffect, useState } from "react";
import Calendar from "react-calendar";
import "./CalendarUI.css";
import "react-calendar/dist/Calendar.css";
import {
  FaCheckCircle,
  FaHourglassHalf,
  FaTimesCircle,
  FaPowerOff,
  FaCalendarPlus,
  FaMinusCircle,
  FaCalendarCheck,
} from "react-icons/fa";
import Heading from "../Heading/Heading";
import { APICall } from "../../Helpers/API/APICalls";
import {
  getCalendarData,
  calendarExportToExcel,
  GetDropDownList,
  gettotalworkingdays,
  getEmployeeAvailableLeaveBalance,
  getMonthTaskDetails,
} from "../../Helpers/API/APIEndPoints";
import { getContext, LoaderContext } from "../../Helpers/Context/Context";
import moment from "moment";
import { Card } from "react-bootstrap";
import SelectForm from "../SelectForm/SelectForm";
import InputForm from "../InputForm/InputForm";
import { Tooltip } from "@mui/material";
import axios from "axios";
import fileDownload from "js-file-download";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import context from "react-bootstrap/esm/AccordionContext";
import { IoShieldHalfOutline } from "react-icons/io5";
// import halfDay from "img/clock-color-icon.svg";
const CalendarUI = () => {
 // console.log("caleder UIX");
  const [value, onChange] = useState(new Date());
  const [showDesc, setShowDesc] = useState("");
  const [apiData, setApiData] = useState(null);
  const [tooltipVisible, setTooltipVisible] = useState(null);
  const [taskDetails, setTaskDetails] = useState(null);
  let checkdate: any = moment().format(moment.HTML5_FMT.DATE);
  const [month, setMonth] = useState(moment().month() + 1); // Current month
  const [year, setYear] = useState(moment().year()); // Current year
  const [resourceAllocatedOptions, setResourceAllocatedOptions] = useState<any>(
    []
  );
    const { showLoader, hideLoader } = useContext(LoaderContext);
  
  const { EmployeeId, RoleId } = getContext();
  const RoleIdArray = RoleId.split(",");
  const [resourceAllocated, setResourceAllocated] = useState<any>({
    value: Number(EmployeeId),
  });
  const [totalworkingdaysemp, setTotalworkingdaysemp] = useState(null); // Add by Pinky for totalworking days
  const [formError, setFormError] = useState({});
  const [leaveBalance, setLeaveBalance] = useState(0);
  const [totalAvailableMandays, setTotalAvailableMandays] = useState<any>(""); //Omkar P
  const [counts, setCounts] = useState({
    "full day approved leave": 0,
    "first half day approved leave": 0,
    "second half day approved leave": 0,
    "applied leave": 0,
    "worked on weekend": 0,
    "worked on holiday": 0,
    "worked on half day leave": 0,
    "worked on half day leave approved": 0,
    "total working days": 0,
    "half day Applied leave": 0,
    "first half day applied leave": 0,
    "second half day applied leave": 0,
    holiday: 0,
    weekend: 0,
    notfilled: 0,
    full: 0,
    discrepancy: 0,
    planned: 0,
  });
  let formErrorObj = {};

  const selectOnChange = async (event: any, apiFieldName: any) => {
    if (apiFieldName === "resourceAllocated") {
      setResourceAllocated(event);
      if (event && Object.keys(event).length > 0) {
      } else if (!event || Object.keys(event).length === 0) {
        setFormError((preState) => ({
          ...preState,
          ["resourceAllocated_isEmpty"]: "Resource allocated can not be empty",
        }));
        formErrorObj["resourceAllocated_isEmpty"] =
          "Resource allocated can not be empty";
      }
    }
  };

  const getData = async () => {
    showLoader()
    //debugger;
    const obj = {
      EmployeeId: resourceAllocated.value,
      Month: Number(month),
      Year: Number(year),
    };
    const { data } = await APICall(getCalendarData, "POST", obj);

    if (data !== null) {
      data?.map(
        (ele) =>
          (ele.date = new Date(moment(ele.date).format(moment.HTML5_FMT.DATE)))
      );
      setApiData(data);

      //count
      for (let key in counts) {
        let count = data.filter((obj) => obj.status === key.toString()).length;
        setCounts((prev) => ({ ...prev, [key]: count }));
      }
    }
    hideLoader()
  };
  const getTotalworkingdays = async () => {
    //debugger;
    const obj = {
      EmployeeId: resourceAllocated.value,
      Month: Number(month),
      Year: Number(year),
    };
    const { data } = await APICall(gettotalworkingdays, "POST", obj);

    if (data !== null) {
      //   data.map(
      //     (ele) =>
      //       (ele.date = new Date(moment(ele.date).format(moment.HTML5_FMT.DATE)))
      //   );
      setTotalworkingdaysemp(data[0].totalWorkingDays);

      //count
      // for (let key in counts) {
      //   let count = data.filter((obj) => obj.status === key.toString()).length;
      //   setCounts((prev) => ({ ...prev, [key]: count }));
      // }
    }
  };

  const getTotalworkingdaysonMonthChange = async (
    selectedMonth,
    selectedYear
  ) => {
    const obj = {
      EmployeeId: resourceAllocated.value,
      Month: Number(selectedMonth),
      Year: Number(selectedYear),
    };
    const { data } = await APICall(gettotalworkingdays, "POST", obj);

    // await data.map(
    //   (ele) =>
    //     (ele.date = new Date(moment(ele.date).format(moment.HTML5_FMT.DATE)))
    // );

    setTotalworkingdaysemp(data[0].totalWorkingDays);

    //console.log(totalworkingdaysemp);

    //count
    // for (let key in counts) {
    //   let count = data.filter((obj) => obj.status === key.toString()).length;
    //   setCounts((prev) => ({ ...prev, [key]: count }));
    // }
  };

  const getEmployeeLeave = async () => {
    const { data } = await APICall(getEmployeeAvailableLeaveBalance, "POST", {
      EmployeeId: resourceAllocated.value,
    });
    if (data > 0) {
      setLeaveBalance(data);
    } else {
      setLeaveBalance(0);
    }
  };

  const getCalenderDataOnMonthChange = async (selectedMonth, selectedYear) => {
    showLoader()
    const obj = {
      EmployeeId: resourceAllocated.value,
      Month: Number(selectedMonth),
      Year: Number(selectedYear),
    };
    const { data } = await APICall(getCalendarData, "POST", obj);

    await data?.map(
      (ele) =>
        (ele.date = new Date(moment(ele.date).format(moment.HTML5_FMT.DATE)))
    );
    setApiData(data);

    //count
    for (let key in counts) {
      let count = data.filter((obj) => obj.status === key.toString()).length;
      setCounts((prev) => ({ ...prev, [key]: count }));
    }
    hideLoader()
  };

  useEffect(() => {
    let taskDetails = null;
    const getTaskDetails = async () => {
      const obj = {
        EmployeeId: resourceAllocated.value,
        Month: Number(month),
        Year: Number(year),
      };

      taskDetails = await APICall(getMonthTaskDetails, "POST", obj);

      if (
        taskDetails &&
        taskDetails.status === 0 &&
        taskDetails?.data?.length > 0
      ) {
        setTaskDetails(taskDetails.data);
      }
    };
    getTaskDetails();
  }, [apiData]);

  useEffect(() => {
    resourceApiCall();
  }, []);

  useEffect(() => {
    getData();
    getTotalworkingdays();
    getEmployeeLeave();
  }, [resourceAllocated]);

  // useEffect(() => {
  //   totalWorkingDays(); // Call totalWorkingDays here
  // }, [counts]); // Add counts as a dependency

  //prashant... To change the text color of weekend
  const getTileClassName = ({ date, view }) => {
    if (view === "month" && (date.getDay() === 0 || date.getDay() === 6)) {
      // Sunday or Saturday
      return "weekend-day";
    }
    return null;
  };

  const theme = createTheme({
    components: {
      MuiTooltip: {
        styleOverrides: {
          tooltip: {
            backgroundColor: "#7CB9E8", // Change background color
            color: "white", // Change text color
            border: "1px solid white", // Optional: Add border
            minWidth: "fit-content",
            visibility: "visible" /* Hidden by default */,
            opacity: "1" /* Invisible by default */,
            position: "absolute",
            right: "-400px",
            transform: "translateX(-50%)" /* Offset the horizontal centering */,
            padding: "0px" /* Some padding for the tooltip */,
            borderRadius: "4px" /* Optional: round corners */,
            transition: "opacity 0.2s" /* Fade-in effect */,
            zIndex:
              "10" /* Make sure the tooltip appears above other content */,
          },
        },
      },
    },
  });

  const tileContent = ({ activeStartDate, date, view }) => {
    let tempApiData = [...apiData];

    tempApiData?.forEach((element) => {
      element.pastTaskDetails = taskDetails?.find(
        (x) =>
          moment(x.fullDate).format("MM-DD-YYYY") ===
          moment(element.date).format("MM-DD-YYYY")
      )?.pastTaskDetails;

      element.futureTaskDetails = taskDetails?.find(
        (x) =>
          moment(x.fullDate).format("MM-DD-YYYY") ===
          moment(element.date).format("MM-DD-YYYY")
      )?.futureTaskDetails;
    });

    // if (date.toLocaleDateString() === new Date().toLocaleDateString()) {
    //   return (
    //     <p>
    //       <FaHourglassHalf color="orange" />
    //     </p>
    //   );
    // }
    if (
      view === "month" &&
      tempApiData.find((ele) => ele.date.getDate() === date.getDate())
    ) {
      let status = tempApiData.find(
        (ele) => ele.date.getDate() === date.getDate()
      ).status;
      let employeeTimeSheetValue = tempApiData.find(
        (ele) => ele.date.getDate() === date.getDate()
      ).employeeTimeSheetValue;
      let pastTaskDetails = tempApiData.find(
        (ele) => ele.date.getDate() === date.getDate()
      ).pastTaskDetails;

      let futureTaskDetails = tempApiData.find(
        (ele) => ele.date.getDate() === date.getDate()
      ).futureTaskDetails;

      let taskDetailsArray = [];

      if (pastTaskDetails) {
        let formattedData = `[${pastTaskDetails}]`
            .replace(/\r?\n/g, "\\n")  // Escape all newline variations
            .replace(/\t/g, " ")       // Replace tabs with spaces
            .replace(/\r/g, " ")       // Remove carriage returns
            .replace(/([{,])(\s*)([a-zA-Z0-9_]+):/g, '$1"$3":')  // Wrap keys in double quotes (supports numbers/underscores)
            .replace(/"([^"]*)"/g, (match, p1) => 
                `"${p1.replace(/\\/g, "\\\\").replace(/"/g, '\\"')}"`  // Escape `\` and `"`
            );

        // const formattedData = `[${pastTaskDetails}]`
        //   .replace(/\n/g, "\\n")
        //   .replace(/([{,])(\s*)([a-zA-Z]+):/g, '$1"$3":')
        //   .replace(/"([^"]*)"/g, (match, p1) => `"${p1.replace(/"/g, '\\"')}"`); // Escape quotes

       // console.log('formatted data==>',formattedData);
        const dataArray = JSON.parse(formattedData);
       // console.log('dataarray==>',dataArray)

        taskDetailsArray = dataArray;
      }

      if (futureTaskDetails) {
        const formattedData = `[${futureTaskDetails}]`
          .replace(/\n/g, "\\n")
          .replace(/([{,])(\s*)([a-zA-Z]+):/g, '$1"$3":')
          .replace(/"([^"]*)"/g, (match, p1) => `"${p1.replace(/"/g, '\\"')}"`); // Escape quotes
       // console.log(formattedData);
        const dataArray = JSON.parse(formattedData);

        taskDetailsArray = dataArray;
      }

      switch (status) {
        case "full day approved leave":
          return (
            <p>
              <FaCalendarPlus color="blue" />
            </p>
          );
        case "first half day approved leave":
          return (
            <p>
              <FaCalendarPlus color="aqua" />
            </p>
          );
        case "second half day approved leave":
          return (
            <p>
              <FaCalendarPlus color="aqua" />
            </p>
          );
        case "worked on half day leave":
          if (taskDetailsArray.length > 0) {
            return (
              <ThemeProvider theme={theme}>
                <Tooltip
                  title={
                    <table
                      style={{
                        border: "1px solid white",
                        backgroundColor: "#7CB9E8",
                      }}
                    >
                      <thead>
                        <tr>
                          <th
                            style={{
                              border: "1px solid white",
                              padding: "7px",
                              fontSize: "0.8rem"
                            }}
                          >
                            Engagement
                          </th>
                          <th
                            style={{
                              border: "1px solid white",
                              padding: "7px",
                              fontSize: "0.8rem"
                            }}
                          >
                            Task / Ticket / Issue
                          </th>
                          <th
                            style={{
                              border: "1px solid white",
                              padding: "7px",
                              fontSize: "0.8rem"
                            }}
                          >
                            Hours Spent
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {taskDetailsArray.length > 0 &&
                          taskDetailsArray?.map((item, index) => (
                            <tr key={index}>
                              <td
                                style={{
                                  border: "1px solid white",
                                  padding: "7px",
                                  fontSize: "0.8rem"
                                }}
                              >
                                {item.EngagementName}
                              </td>
                              <td
                                style={{
                                  border: "1px solid white",
                                  padding: "7px",
                                  fontSize: "0.8rem"
                                }}
                              >
                                {item.Activity}
                              </td>
                              <td
                                style={{
                                  border: "1px solid white",
                                  padding: "7px",
                                  fontSize: "0.8rem"
                                }}
                              >
                                {item.Hours}
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  }
                  key={moment(date, "DD-MM-YYYY").format("DD-MM-YYYY")}
                >
                  <p>
                    <FaCheckCircle color="green" />
                    <FaCalendarPlus color="Salmon" />
                  </p>
                </Tooltip>
              </ThemeProvider>
              // <p>
              //   <FaCheckCircle color="green" />
              //   <FaCalendarPlus color="Salmon" />
              //   {/* <i className="fa-solid fa-calendar-check"></i> */}
              // </p>
            );
          } else {
            return (
              <p>
                <FaCheckCircle color="green" />
                <FaCalendarPlus color="Salmon" />
              </p>
            );
          }
        case "worked on half day leave approved":
          return (
            <ThemeProvider theme={theme}>
              <Tooltip
                title={
                  <table
                    style={{
                      border: "1px solid white",
                      backgroundColor: "#7CB9E8",
                    }}
                  >
                    <thead>
                      <tr>
                        <th
                          style={{
                            border: "1px solid white",
                            padding: "7px",
                            fontSize: "0.8rem"
                          }}
                        >
                          Engagement
                        </th>
                        <th
                          style={{
                            border: "1px solid white",
                            padding: "7px",
                            fontSize: "0.8rem"
                          }}
                        >
                          Task / Ticket / Issue
                        </th>
                        <th
                          style={{
                            border: "1px solid white",
                            padding: "7px",
                            fontSize: "0.8rem"
                          }}
                        >
                          Hours Spent
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {taskDetailsArray.length > 0 &&
                        taskDetailsArray?.map((item, index) => (
                          <tr key={index}>
                            <td
                              style={{
                                border: "1px solid white",
                                padding: "7px",
                                fontSize: "0.8rem"
                              }}
                            >
                              {item.EngagementName}
                            </td>
                            <td
                              style={{
                                border: "1px solid white",
                                padding: "7px",
                                fontSize: "0.8rem"
                              }}
                            >
                              {item.Activity}
                            </td>
                            <td
                              style={{
                                border: "1px solid white",
                                padding: "7px",
                                fontSize: "0.8rem"
                              }}
                            >
                              {item.Hours}
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                }
                key={moment(date, "DD-MM-YYYY").format("DD-MM-YYYY")}
              >
                <p>
                  <FaCheckCircle color="green" /> {""}
                  <FaCalendarPlus color="aqua" />
                </p>
              </Tooltip>
            </ThemeProvider>
            // <p>
            //   <FaCheckCircle color="green" /> {""}
            //   <FaCalendarPlus color="aqua" />
            // </p>
          );
        // case "first half day approved leave and discrepancy":
        //   return (
        //     <p>
        //       <FaCalendarPlus color="blue" />{" "}<FaCheckCircle color="yellow" />
        //     </p>
        //   );
        // case "second half day approved leave and discrepancy":
        //   return (
        //     <p>
        //       <FaCalendarPlus color="blue" />{" "}<FaCheckCircle color="yellow" />
        //     </p>
        //   );
        // case "half day Applied leave":
        //   return (
        //     <p>
        //       <i className="fas fa-clock"></i>
        //     </p>
        //   );
        case "applied leave":
          return (
            <p>
              <FaCalendarPlus color="orange" />
            </p>
          );
        //Pinky Shah for Hald day Applied Leave 24 jan 2024
        case "first half day applied leave":
          return (
            <p>
              <FaCalendarPlus color="salmon" />
            </p>
          );
        case "second half day applied leave":
          return (
            <p>
              <FaCalendarPlus color="salmon" />
            </p>
          );
        //Pinky Shah

        case "holiday":
          return (
            <p>
              <FaPowerOff color="grey" />
            </p>
          );
        case "worked on holiday":
          if (taskDetailsArray.length > 0) {
            return (
              <ThemeProvider theme={theme}>
                <Tooltip
                  title={
                    <table
                      style={{
                        border: "1px solid white",
                        backgroundColor: "#7CB9E8",
                      }}
                    >
                      <thead>
                        <tr>
                          <th
                            style={{
                              border: "1px solid white",
                              padding: "7px",
                              fontSize: "0.8rem"
                            }}
                          >
                            Engagement
                          </th>
                          <th
                            style={{
                              border: "1px solid white",
                              padding: "7px",
                              fontSize: "0.8rem"
                            }}
                          >
                            Task / Ticket / Issue
                          </th>
                          <th
                            style={{
                              border: "1px solid white",
                              padding: "7px",
                              fontSize: "0.8rem"
                            }}
                          >
                            Hours Spent
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {taskDetailsArray.length > 0 &&
                          taskDetailsArray?.map((item, index) => (
                            <tr key={index}>
                              <td
                                style={{
                                  border: "1px solid white",
                                  padding: "7px",
                                  fontSize: "0.8rem"
                                }}
                              >
                                {item.EngagementName}
                              </td>
                              <td
                                style={{
                                  border: "1px solid white",
                                  padding: "7px",
                                  fontSize: "0.8rem"
                                }}
                              >
                                {item.Activity}
                              </td>
                              <td
                                style={{
                                  border: "1px solid white",
                                  padding: "7px",
                                  fontSize: "0.8rem"
                                }}
                              >
                                {item.Hours}
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  }
                  key={moment(date, "DD-MM-YYYY").format("DD-MM-YYYY")}
                >
                  <p>
                    <FaCheckCircle color="green" /> {""}{" "}
                    <FaPowerOff color="grey" />
                  </p>
                </Tooltip>
              </ThemeProvider>
              // <p>
              //   <FaCheckCircle color="green" /> {""} <FaPowerOff color="grey" />
              // </p>
            );
          } else {
            return (
              <p>
                <FaCheckCircle color="green" /> {""} <FaPowerOff color="grey" />
              </p>
            );
          }
        case "weekend":
          return (
            <p>
              <FaMinusCircle color="maroon" />
            </p>
          );
        case "worked on weekend":
          if (taskDetailsArray.length > 0) {
            return (
              <ThemeProvider theme={theme}>
                <Tooltip
                  title={
                    <table
                      style={{
                        border: "1px solid white",
                        backgroundColor: "#7CB9E8",
                      }}
                    >
                      <thead>
                        <tr>
                          <th
                            style={{
                              border: "1px solid white",
                              padding: "7px",
                              fontSize: "0.8rem"
                            }}
                          >
                            Engagement
                          </th>
                          <th
                            style={{
                              border: "1px solid white",
                              padding: "7px",
                              fontSize: "0.8rem"
                            }}
                          >
                            Task / Ticket / Issue
                          </th>
                          <th
                            style={{
                              border: "1px solid white",
                              padding: "7px",
                              fontSize: "0.8rem"
                            }}
                          >
                            Hours Spent
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {taskDetailsArray.length > 0 &&
                          taskDetailsArray?.map((item, index) => (
                            <tr key={index}>
                              <td
                                style={{
                                  border: "1px solid white",
                                  padding: "7px",
                                  fontSize: "0.8rem"
                                }}
                              >
                                {item.EngagementName}
                              </td>
                              <td
                                style={{
                                  border: "1px solid white",
                                  padding: "7px",
                                  fontSize: "0.8rem"
                                }}
                              >
                                {item.Activity}
                              </td>
                              <td
                                style={{
                                  border: "1px solid white",
                                  padding: "7px",
                                  fontSize: "0.8rem"
                                }}
                              >
                                {item.Hours}
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  }
                  key={moment(date, "DD-MM-YYYY").format("DD-MM-YYYY")}
                >
                  <p>
                    <FaCheckCircle color="green" /> {""}
                    <FaMinusCircle color="maroon" />
                  </p>
                </Tooltip>
              </ThemeProvider>

              // <p>
              //   <FaCheckCircle color="green" /> {""}
              //   <FaMinusCircle color="maroon" />
              // </p>
            );
          } else {
            return (
              <p>
                <FaCheckCircle color="green" /> {""}
                <FaMinusCircle color="maroon" />
              </p>
            );
          }
        case "notfilled":
          if (employeeTimeSheetValue == 0) {
            return <p>&nbsp;</p>;
          } else {
            return (
              <p>
                <FaTimesCircle color="red" />
              </p>
            );
          }

        case "full":
          if (employeeTimeSheetValue == 0) {
            return <p>&nbsp;</p>;
          } else {
            if (taskDetailsArray.length > 0) {
              return (
                <ThemeProvider theme={theme}>
                  <Tooltip
                    placement="bottom"
                    title={
                      <table
                        style={{
                          border: "1px solid white",
                          backgroundColor: "#7CB9E8",
                        }}
                      >
                        <thead>
                          <tr>
                            <th
                              style={{
                                border: "1px solid white",
                                padding: "7px",
                                fontSize: "0.8rem"
                              }}
                            >
                              Engagement
                            </th>
                            <th
                              style={{
                                border: "1px solid white",
                                padding: "7px",
                                fontSize: "0.8rem"
                              }}
                            >
                              Task / Ticket / Issue
                            </th>
                            <th
                              style={{
                                border: "1px solid white",
                                padding: "7px",
                                fontSize: "0.8rem"
                              }}
                            >
                              Hours Spent
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {taskDetailsArray.length > 0 &&
                            taskDetailsArray?.map((item, index) => (
                              <tr key={index}>
                                <td
                                  style={{
                                    border: "1px solid white",
                                    padding: "7px",
                                    fontSize: "0.8rem"
                                  }}
                                >
                                  {item.EngagementName}
                                </td>
                                <td
                                  style={{
                                    border: "1px solid white",
                                    padding: "7px",
                                    fontSize: "0.8rem"
                                  }}
                                >
                                  {item.Activity}
                                </td>
                                <td
                                  style={{
                                    border: "1px solid white",
                                    padding: "7px",
                                    fontSize: "0.8rem"
                                  }}
                                >
                                  {item.Hours}
                                </td>
                              </tr>
                            ))}
                        </tbody>
                      </table>
                    }
                    key={moment(date, "DD-MM-YYYY").format("DD-MM-YYYY")}
                  >
                    <p>
                      <FaCheckCircle color="green" />
                    </p>
                  </Tooltip>
                </ThemeProvider>
              );
            } else {
              return (
                <p>
                  <FaCheckCircle color="green" />
                </p>
              );
            }
          }

        case "discrepancy":
          if (employeeTimeSheetValue == 0) {
            return <p>&nbsp;</p>;
          } else {
            if (taskDetailsArray.length > 0) {
              return (
                <ThemeProvider theme={theme}>
                  <Tooltip
                    title={
                      <table
                        style={{
                          border: "1px solid white",
                          backgroundColor: "#7CB9E8",
                        }}
                      >
                        <thead>
                          <tr>
                            <th
                              style={{
                                border: "1px solid white",
                                padding: "7px",
                                fontSize: "0.8rem"
                              }}
                            >
                              Engagement
                            </th>
                            <th
                              style={{
                                border: "1px solid white",
                                padding: "7px",
                                fontSize: "0.8rem"
                              }}
                            >
                              Task / Ticket / Issue
                            </th>
                            <th
                              style={{
                                border: "1px solid white",
                                padding: "7px",
                                fontSize: "0.8rem"
                              }}
                            >
                              Hours Spent
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {taskDetailsArray.length > 0 &&
                            taskDetailsArray?.map((item, index) => (
                              <tr key={index}>
                                <td
                                  style={{
                                    border: "1px solid white",
                                    padding: "7px",
                                    fontSize: "0.8rem"
                                  }}
                                >
                                  {item.EngagementName}
                                </td>
                                <td
                                  style={{
                                    border: "1px solid white",
                                    padding: "7px",
                                    fontSize: "0.8rem"
                                  }}
                                >
                                  {item.Activity}
                                </td>
                                <td
                                  style={{
                                    border: "1px solid white",
                                    padding: "7px",
                                    fontSize: "0.8rem"
                                  }}
                                >
                                  {item.Hours}
                                </td>
                              </tr>
                            ))}
                        </tbody>
                      </table>
                    }
                    key={moment(date, "DD-MM-YYYY").format("DD-MM-YYYY")}
                  >
                    <p>
                      <FaCheckCircle color="yellow" />
                    </p>
                  </Tooltip>
                </ThemeProvider>

                // <p>
                //   <FaCheckCircle color="yellow" />
                // </p>
              );
            } else {
              return (
                <p>
                  <FaCheckCircle color="yellow" />
                </p>
              );
            }
          }

        case "today":
          return (
            <p>
              <FaHourglassHalf color="orange" />
            </p>
          );

        case "planned":
          if (taskDetailsArray.length > 0) {
            return (
              <ThemeProvider theme={theme}>
                <Tooltip
                  title={
                    <table
                      style={{
                        border: "1px solid white",
                        backgroundColor: "#7CB9E8",
                      }}
                    >
                      <thead>
                        <tr>
                          <th
                            style={{
                              border: "1px solid white",
                              padding: "7px",
                              fontSize: "0.8rem"
                            }}
                          >
                            Engagement
                          </th>
                          <th
                            style={{
                              border: "1px solid white",
                              padding: "7px",
                              fontSize: "0.8rem"
                            }}
                          >
                            Task / Ticket / Issue
                          </th>
                          <th
                            style={{
                              border: "1px solid white",
                              padding: "7px",
                              fontSize: "0.8rem"
                            }}
                          >
                            Hours Assigned
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {taskDetailsArray.length > 0 &&
                          taskDetailsArray?.map((item, index) => (
                            <tr key={index}>
                              <td
                                style={{
                                  border: "1px solid white",
                                  padding: "7px",
                                  fontSize: "0.8rem"
                                }}
                              >
                                {item.EngagementName}
                              </td>
                              <td
                                style={{
                                  border: "1px solid white",
                                  padding: "7px",
                                  fontSize: "0.8rem"
                                }}
                              >
                                {item.Activity}
                              </td>
                              <td
                                style={{
                                  border: "1px solid white",
                                  padding: "7px",
                                  fontSize: "0.8rem"
                                }}
                              >
                                {item.Hours}
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  }
                  key={moment(date, "DD-MM-YYYY").format("DD-MM-YYYY")}
                >
                  <p>
                    <FaCalendarCheck color="black" />
                  </p>
                </Tooltip>
              </ThemeProvider>
            );
          } else {
            return (
              <p>
                <FaCalendarCheck color="black" />
              </p>
            );
          }
        default:
          return <p>&nbsp;</p>;
      }
    }
  };

  const onMonthChange = async ({ action, activeStartDate, value, view }) => {
    if (view === "month") {
      const currentMonthFirstDate = moment(activeStartDate).format(
        moment.HTML5_FMT.DATE
      );
      const selectedMonth = Number(currentMonthFirstDate.split("-")[1]);
      const selectedYear = Number(currentMonthFirstDate.split("-")[0]);
      setMonth(selectedMonth);
      setYear(selectedYear);
      await getCalenderDataOnMonthChange(selectedMonth, selectedYear);
      await getTotalworkingdaysonMonthChange(selectedMonth, selectedYear);
    }
  };

  const resourceApiCall = async () => {
    
    let postObject = {
      searchFor: "employee",
      searchValue: 1,
    };
    const { data } = await APICall(GetDropDownList, "POST", postObject);
    if (data != undefined || data != null) {
      let employeeArray = [];
      await data.map((employee: any) => {
        let tempObj = {
          value: employee.id,
          label: employee.name,
        };
        if (tempObj.value == resourceAllocated.value) {
          setResourceAllocated(tempObj);
        }
        employeeArray.push(tempObj);
      });
      setResourceAllocatedOptions(employeeArray);
    }
  };

  //will use in future//
  const onDateChange = (date) => {
    let temp = { ...apiData };
    if (date.getMonth() === temp.month) {
      let ele = temp.days.find((ele) => ele.date.getDate() === date.getDate());
      if (ele !== undefined) {
        setShowDesc(
          `Status is ${ele.status} & description is ${ele.description}`
        );
      } else {
        setShowDesc("");
      }
      onChange(date);
    }
  };
  //will use in future//
  const ExportToExcel = async () => {
    //debugger;
    axios
      .request({
        responseType: "blob",
        method: "POST",
        //data: Response,
        url: calendarExportToExcel,
        //data:JSON,
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
          "Access-Control-Allow-Headers": "*",
        },
        data: {
          Month: Number(month),
          Year: Number(year),
        },
      })
      .then((response) => {
        fileDownload(response.data, "CalendarReport.xlsx");
      })
      .catch((error) => {
        console.log(error.response.data);
      });
  };

  // Omkar P hello
  const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  // const totalWorkingDays = async () => {
  //   const currentDate = moment();
  //   const getDayInMonth = currentDate.daysInMonth(); //Total month days count
  //   const halfDayAppliedLeave = counts["half day Applied leave"] / 2;

  //   const workingDays =
  //     getDayInMonth -
  //     counts["full day approved leave"] -
  //     counts.holiday -
  //     counts.weekend -
  //     counts["applied leave"] -
  //     halfDayAppliedLeave -
  //     (counts["first half day approved leave"] +
  //       counts["second half day approved leave"]) /
  //       2;

  //   setCounts((prev) => ({ ...prev, "total working days": workingDays }));
  // };
  return (
    <>
      {apiData && (
        <>
          <Heading title={"Calendar"} />
          <div className="container-fluid">
            <div className="row">
              <div className="col-lg-3 col-md-4 col-sm-6">
                <div className="form-group">
                  <label>
                    Employee Selected <sup>*</sup>
                  </label>
                  <SelectForm
                    options={resourceAllocatedOptions}
                    placeholder="Select"
                    isDisabled={
                      RoleIdArray.includes("3") ||
                      RoleIdArray.includes("4") ||
                      RoleIdArray.includes("8") ||
                      RoleIdArray.includes("6")
                        ? false
                        : true
                    }
                    value={resourceAllocated}
                    onChange={(event) =>
                      selectOnChange(event, "resourceAllocated")
                    }
                    isMulti={false}
                    noIndicator={false}
                    noSeparator={false}
                  />
                  <span style={{ color: "red" }}>
                    {formError["resourceAllocated_isEmpty"]}
                  </span>
                </div>
              </div>
              <div className="col-lg-3 col-md-4 col-sm-6">
                <div className="form-group">
                  <label>Leave Balance</label>
                  <InputForm
                    placeholder={"Leave days"}
                    isDisabled={true}
                    textArea={false}
                    value={leaveBalance}
                    onChange={(e) => {}}
                    className="numRight"
                    type="number"
                    onKeyPress={(event) => {
                      if (!/^[0-9]*(\.[0-9]{0,2})?$/.test(event.key)) {
                        event.preventDefault();
                      }
                    }}
                  />
                  <p style={{ color: "red" }}>
                    {formError["leaveBalance_isEmpty"]}
                  </p>
                </div>
              </div>

              {/* {<div className="col-lg-3 col-md-4 col-sm-6">
                  <div className="form-group">
                    <Tooltip
                      title="Export to excel"
                      hidden={
                        RoleIdArray.includes("3") ||
                        RoleIdArray.includes("4") ||
                        RoleIdArray.includes("6")
                          ? false
                          : true
                      }
                    >
                      <button
                        onClick={() => ExportToExcel()}
                        className="btn btn-secondary mr-2 mt-4"
                      >
                        <i className="fa-solid fa-file-arrow-down"></i>
                      </button>
                    </Tooltip>
                  </div>
                </div>
              </div> } */}
            </div>
            <div className="row">
              <div className="col-lg-8 col-md-12 col-sm-12 cal-div">
                <Calendar
                  onChange={() => {}} // onDateChange
                  value={value}
                  tileContent={tileContent}
                  showNeighboringMonth={false}
                  onActiveStartDateChange={onMonthChange}
                  minDetail="century"
                  // Update minDate
                  minDate={new Date(new Date().getFullYear() - 1, 0, 1)}
                  // Update maxDate
                  maxDate={new Date(new Date().getFullYear() + 1, 11, 31)}
                  navigationLabel={({ date, view }) => {
                    const month = date.getMonth();
                    const year = date.getFullYear();
                    return `${monthNames[month]} ${year}`;
                  }}
                  prev2Label={"‹‹"} //  label add for the previous year
                  next2Label={"››"} //  label add for the next year
                  tileClassName={getTileClassName} //prashant
                />
              </div>
              <div className="col-lg-4 col-md-12 col-sm-12">
                <Card className="legends-card">
                  <Card.Title className="title-calendar mb-0">
                    Calendar Legends
                  </Card.Title>
                  <Card.Body className="legends-body">
                    <table className="table table-bordered legends-table mb-0">
                      <thead>
                        <tr>
                          <th>Name</th>
                          <th>Icon</th>
                          <th>Days</th>
                        </tr>
                      </thead>
                      <tbody>
                        {/* Full Day */}
                        <tr>
                          <td>Full day</td>
                          <td>
                            <FaCheckCircle color="green" />
                          </td>
                          <td>{counts.full}</td>
                        </tr>
                        {/* Discrepancy */}
                        <tr>
                          <td>Discrepancy</td>
                          <td>
                            <FaCheckCircle color="yellow" />
                          </td>
                          <td>{counts.discrepancy}</td>
                        </tr>
                        {/* Full Day Approved Leave */}
                        <tr>
                          <td>Full Day Approved Leave</td>
                          <td>
                            <FaCalendarPlus color="blue" />
                          </td>
                          <td>{counts["full day approved leave"]}</td>
                        </tr>
                        {/* Half Day Approved Leave */}
                        <tr>
                          <td>Half Day Approved Leave</td>
                          <td>
                            <FaCalendarPlus color="aqua" />
                          </td>
                          <td>
                            {counts["first half day approved leave"] / 2 +
                              counts["second half day approved leave"] / 2 +
                              counts["worked on half day leave approved"] / 2}
                            {/* {
                                (counts["first half day approved leave"] +
                                  counts["second half day approved leave"]) /
                                  2
                                // counts["worked on half day leave approved"]
                              } */}
                          </td>
                        </tr>
                        {/* <tr>
                            <td>Half Day Applied Leave</td>
                            <td>
                              <i
                                style={{ color: "yellow" }}
                                className="fas fa-clock"
                              ></i>
                            </td>
                            <td>{counts["half day Applied leave"] / 2}</td>
                          </tr> */}

                        {/* Full day Applied leave */}
                        <tr>
                          <td>Full day Applied leave</td>
                          <td>
                            <FaCalendarPlus color="orange" />
                          </td>
                          <td>
                            {
                              counts["applied leave"]
                              // +counts["worked on half day leave"]
                            }
                          </td>
                        </tr>
                        {/*Hald day Applied Leave  */}
                        <tr>
                          <td>Half Day Applied Leave</td>
                          <td>
                            <FaCalendarPlus color="Salmon" />
                          </td>
                          <td>
                            {counts["second half day applied leave"] / 2 +
                              counts["first half day applied leave"] / 2 +
                              counts["worked on half day leave"] / 2}
                          </td>
                        </tr>
                        {/* Holiday */}
                        <tr>
                          <td>Holiday</td>
                          <td>
                            <FaPowerOff color="grey" />{" "}
                          </td>
                          <td>
                            {counts.holiday + counts["worked on holiday"]}
                          </td>
                        </tr>
                        {/* Not filled */}
                        <tr>
                          <td>Not filled</td>
                          <td>
                            <FaTimesCircle color="red" />
                          </td>
                          <td>{counts.notfilled}</td>
                        </tr>
                        {/* Weekend */}
                        <tr>
                          <td>Weekend</td>
                          <td>
                            <FaMinusCircle color="maroon" />
                          </td>
                          <td>
                            {counts.weekend + counts["worked on weekend"]}
                          </td>
                        </tr>
                        <tr>
                          <td>CompOff</td>
                          <td>
                            <div>
                              <FaCheckCircle color="green" /> {""}
                              <FaMinusCircle color="maroon" />
                            </div>
                          </td>
                          <td>
                            {counts["worked on weekend"] +
                              counts["worked on holiday"]}
                          </td>
                        </tr>
                        <tr>
                          <td>Planned</td>
                          <td>
                            <div>
                              <FaCalendarCheck color="black" />
                            </div>
                          </td>
                          <td>{counts["planned"]}</td>
                        </tr>
                        {/* Total */}
                        <tr>
                          <td>Working days</td>
                          <td></td>
                          <td>
                            {/* {counts.weekend +
                                counts["worked on weekend"] +
                                counts.notfilled +
                                counts.holiday +
                                counts["worked on holiday"] +
                                counts["applied leave"] +
                                counts["worked on half day leave"] +
                                counts["worked on half day leave approved"] +
                                counts["first half day approved leave"] +
                                counts["second half day approved leave"] +
                                counts["full day approved leave"] +
                                counts.discrepancy +
                                counts.full} */}
                            {totalworkingdaysemp}
                          </td>
                        </tr>

                        {/* <tr>
                            <td>Total Working Days</td>
                            <td>
                              <i className="fa-solid fa-briefcase"></i>
                            </td>
                            <td>{counts["total working days"]}</td>
                          </tr> */}
                        {/* Omkar P */}
                      </tbody>
                    </table>
                  </Card.Body>
                </Card>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default CalendarUI;
